import type {ComponentType, RefObject} from 'react'

import {PromotionalBanner, type PromotionalBannerPayload} from './PromotionalBanner'
import {CopilotAppBanner} from '../copilot-app-banner/CopilotAppBanner'
import {AnnouncementBanner} from '../announcement-banner/AnnouncementBanner'

export interface CopilotPromotionalBannerProps {
  banner: PromotionalBannerPayload
  rounded?: boolean
  returnFocusRef?: RefObject<HTMLElement | null>
}

/** Campaigns whose presentation needs more than the payload carries: artwork, icons, or a client-side choice of CTA. */
const CAMPAIGN_ADAPTERS: Record<string, ComponentType<CopilotPromotionalBannerProps>> = {
  copilot_app: CopilotAppBanner,
}

export function CopilotPromotionalBanner({banner, rounded, returnFocusRef}: CopilotPromotionalBannerProps) {
  if (banner.announcement) {
    return (
      <AnnouncementBanner key={banner.nudgeId ?? banner.campaign} banner={banner} returnFocusRef={returnFocusRef} />
    )
  }

  const Campaign = CAMPAIGN_ADAPTERS[banner.campaign]

  return Campaign ? (
    <Campaign banner={banner} rounded={rounded} />
  ) : (
    <PromotionalBanner banner={banner} rounded={rounded} />
  )
}
